import styled from 'styled-components';

// Components
import { Colors, InlineChildren, Spacing, Text } from '@doordash/design-language';
import BackButton from 'components/buttons/BackButton';
import CheckoutInstructionsCard from 'components/checkout-modules/CheckoutInstructionsCard';
import { Alert, Button, Card } from 'top-component-library';
// Types
import { AlertProps, ButtonProps } from 'antd';
import breakpoints from 'constants/breakpoints';
import React from 'react';

export const Container = styled.div`
  background-color: var(--color-neutral__card-background);
  border-top-left-radius: ${Spacing.Large}px;
  border-top-right-radius: ${Spacing.Large}px;
  color: var(--color-neutral__body);
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media (min-width: ${breakpoints.md}px) {
    border-top-left-radius: var(--border-radius__small);
    border-top-right-radius: var(--border-radius__small);
    height: auto;
  }
`;

export const ContentContainer = styled.div<{ 'flex-grow'?: number; spacing?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ spacing }) => spacing ?? Spacing.Large}px;
  flex-grow: ${({ 'flex-grow': flexGrow = 0 }) => flexGrow};
  box-sizing: border-box;
  padding: 1.5rem 1rem;
  border-bottom: var(--tabs-border-radius__regular) var(--tabs-border-style__regular) ${Colors.BackgroundSecondary};
`;

export const ContentCard = styled(Card)`
  border: none;

  &&& .ant-card-bordered {
    border: none;
  }

  .ant-card-head {
    border: none;
    padding: 0;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: normal;
    letter-spacing: 0.93px;
    text-transform: uppercase;
    color: var(--tabs-text-color__primary);
    min-height: 12px;
  }

  .ant-card-body {
    padding: 0;
  }

  .ant-card-head-title,
  .ant-card-extra {
    padding: 0 0 1.5rem 0;
  }
`;

export const TabModalCloseTabButton: React.FunctionComponent<ButtonProps> = styled(Button)`
  width: 100%;

  &.ant-btn {
    align-self: stretch;
    background: ${Colors.SystemBlack};
    border-color: ${Colors.SystemBlack};
    border-radius: var(--button__border-radius);
    font-size: 14px;
    height: 50px;
    padding: 0 2rem;

    span {
      color: #fff;
    }

    &:disabled,
    &:disabled:focus,
    &:disabled:hover {
      background-color: var(--color-neutral__line);
      border-color: var(--color-neutral__line);
    }

    &:hover {
      border-color: ${Colors.SystemBlack};
      filter: brightness(200%);
    }
  }
`;

export const StyledBackButton = styled(BackButton)`
  justify-self: flex-start;
  margin-bottom: 1.25rem;
`;

export const ClosingTabText = styled(Text)`
  margin-top: 1rem;
  font-weight: 700;
  font-size: 20px;
  line-height: normal;
  letter-spacing: 0.75px;
  color: var(--tabs-text-color__primary);
`;

export const FullscreenLoading = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  background: rgba(51, 51, 51, 0.7);
  z-index: 110;

  span {
    color: var(--tabs-text-color__white);
  }
`;

export const Spacer = styled.div`
  flex: 1 1 auto;
`;

export const Footer = styled.div`
  background: var(--color-neutral__modal-background);
  bottom: 0;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
  padding: 1rem;
  position: -webkit-sticky;
  position: sticky;
  width: 100%;
  z-index: 100;

  &.card {
    margin-top: 0.25rem;
    padding: 1.5rem 1.5rem 0;
  }

  &.drawer:not(.no-margin-top) {
    margin-top: 1.5rem;
  }

  @media (min-width: ${breakpoints.md}px) {
    &.card {
      margin-top: 1rem;
      padding: 0 1.5rem;
    }
  }
`;

export const StyledAlert: React.FunctionComponent<AlertProps> = styled(Alert)`
  &&&.ant-alert {
    background-color: var(--tabs-background-color__secondary);
    border-color: var(--color-neutral__line);
    text-align: center;
    width: 100%;
  }

  .ant-alert-message {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.75px;
    color: var(--tabs-text-color__primary);
  }
`;

export const ContentNote = styled.div`
  padding: ${Spacing.Large}px 1rem ${Spacing.Large}px 1rem;
`;

export const InstructionsCard = styled(CheckoutInstructionsCard)`
  border: none;

  &.top {
    padding-top: 1.25rem;
  }
`;

export const PaymentText = styled(Text)`
  font-size: 20px;
  font-weight: 700;
`;

export const ButtonContentWrapper = styled(InlineChildren)`
  width: 100%;
  justify-content: space-between;
`;

export const HorizonalSpacer = styled.div`
  width: 110%;
  margin-left: -5%;
  border-top: 6px solid ${Colors.BackgroundSecondary};
`;
